export default __webpack_public_path__ + "6584fae5a94c66dd29f69056b031d7e3.png";